import { PALETTE, HeldBook, SeatedFigure, Shadow, Star } from "./parts";

/** Başörtülü, yüzsüz bir kadın figürü minder üzerinde kitap okuyor. */
export default function BookReader({ className = "" }) {
  const { cloud, mist, soft, gold, orange, skin, brand } = PALETTE;
  return (
    <svg viewBox="0 0 320 300" className={className} role="img" aria-hidden="true" focusable="false">
      <circle cx={160} cy={152} r={132} fill={cloud} />
      {/* kemerli pencere */}
      <path d="M100,240 L100,120 Q100,64 160,54 Q220,64 220,120 L220,240 Z" fill={mist} />
      <path d="M114,240 L114,124 Q114,78 160,69 Q206,78 206,124 L206,240 Z" fill="#E4F2F2" />
      {/* sekiz köşeli yıldız süsü */}
      <g transform="translate(160 84)" fill="none" stroke={soft} strokeWidth={1.4}>
        <rect x={-7} y={-7} width={14} height={14} />
        <rect x={-7} y={-7} width={14} height={14} transform="rotate(45)" />
      </g>
      <Star x={62} y={96} r={5} color={gold} opacity={0.8} />
      <Star x={256} y={78} r={4} color={gold} opacity={0.7} />
      <Star x={246} y={130} r={2.8} color={orange} opacity={0.5} />
      {/* küçük saksı bitkisi */}
      <g transform="translate(252 250)">
        <path d="M-12,0 L-9,-18 L9,-18 L12,0 Z" fill={orange} opacity={0.85} />
        <path d="M0,-18 Q-2,-40 -16,-50 Q-4,-40 0,-18 Z" fill={brand} />
        <path d="M0,-18 Q4,-44 18,-54 Q8,-40 0,-18 Z" fill={PALETTE.deep} />
        <path d="M0,-18 Q-10,-30 -22,-30 Q-10,-24 0,-18 Z" fill={soft} />
      </g>

      {/* minder */}
      <Shadow cx={160} cy={270} rx={96} ry={11} opacity={0.12} />
      <rect x={82} y={250} width={156} height={20} rx={10} fill={gold} opacity={0.9} />
      <path d="M92,256 L228,256" stroke="#FFFFFF" strokeWidth={1.4} strokeDasharray="3 5" opacity={0.6} />

      <SeatedFigure
        x={160}
        y={256}
        scale={1.3}
        headwear="hijab"
        scarf={PALETTE.deep}
        robe={brand}
        robeDark="#3B8F90"
        arms="read"
      />
      <HeldBook x={160} y={209} w={66} />
      {/* kitabı tutan eller */}
      <circle cx={127} cy={214} r={6} fill={skin} />
      <circle cx={193} cy={214} r={6} fill={skin} />
    </svg>
  );
}
